import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./LegalPage.css";
import logo from "../assets/images/roster_connect_icon.png";

export default function RosterPrivacy() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    fetch("https://itpiloten.dk/flightplan/api/privacy.json")
      .then((res) => res.json())
      .then((json) => {
        setData(json);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Fejl ved hentning af politik:", err);
        setLoading(false);
      });
  }, []);

  const renderText = (text) => {
    if (!text) return "";
    const parts = text.split(/(\*\*.*?\*\*)/g);
    return parts.map((part, i) => {
      if (part.startsWith("**") && part.endsWith("**")) {
        return <strong key={i}>{part.slice(2, -2)}</strong>;
      }
      return part;
    });
  };

  if (loading) {
    return (
      <div className="legal-inner">
        <p>Loading Policy...</p>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="legal-inner">
        <p>Kunne ikke indlæse privatlivspolitikken.</p>
      </div>
    );
  }

  return (
    <div className="legal-root rc-legal">
      <header className="legal-header">
        <div className="legal-header-inner">
          <Link to="/roster-connect" className="legal-back">
            <img className="rc-logo-icon" src={logo} alt="Logo" />
            Roster Connect
          </Link>

          {/* Burger button — kun synlig på mobil */}
          <button
            className={`legal-burger ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
          >
            <span />
            <span />
            <span />
          </button>

          {/* Nav — på desktop altid synlig, på mobil styret af menuOpen */}
          <nav className={`legal-header-nav ${menuOpen ? "mobile-open" : ""}`}>
            <Link
              to="/roster-connect/privacy"
              className="active"
              onClick={() => setMenuOpen(false)}
            >
              Privacy Policy
            </Link>
            <Link to="/roster-connect/terms" onClick={() => setMenuOpen(false)}>
              Terms
            </Link>
            <Link
              to="/roster-connect/support"
              onClick={() => setMenuOpen(false)}
            >
              Support
            </Link>
          </nav>
        </div>
      </header>

      <main className="legal-main">
        <div className="legal-inner">
          <header className="legal-header-content">
            <div className="legal-meta">
              <span className="legal-tag">{data.appName}</span>
              <span className="legal-updated">
                Last Updated: {data.lastUpdated}
              </span>
            </div>
            <h1>{data.documentTitle}</h1>
          </header>

          {data.sections.map((section, index) => {
            if (section.type === "intro") {
              return (
                <p key={index} className="legal-lead">
                  {renderText(section.content)}
                </p>
              );
            }
            if (section.type === "highlight") {
              return (
                <div key={index} className="privacy-highlight">
                  <h3>{section.title}</h3>
                  <p>{renderText(section.content)}</p>
                </div>
              );
            }
            if (section.type === "section") {
              return (
                <section key={index} className="legal-section">
                  <h2>{section.title}</h2>
                  {section.content && <p>{renderText(section.content)}</p>}
                  {section.list && (
                    <ul>
                      {section.list.map((item, i) => (
                        <li key={i}>{renderText(item)}</li>
                      ))}
                    </ul>
                  )}
                </section>
              );
            }
            return null;
          })}
        </div>
      </main>

      <footer className="legal-footer">
        <div className="legal-footer-inner">
          <Link to="/roster-connect">← Back to Roster Connect</Link>
          <p>
            © {new Date().getFullYear()} {data.appName}. CR Software | CVR:
            46349180
          </p>
          <div className="legal-footer-links">
            <Link to="/roster-connect/terms">Terms of Service</Link>
            <Link to="/roster-connect/support">Support</Link>
            <Link to="/">CR Software ApS</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
